/* c8 ignore start */
import customers from "./customers";
import campaigns from "./campaigns";
import cards from "./cards";

export default {
  customers,
  campaigns,
  cards,
};
/* c8 ignore end */
